/**
 * Vault write — routes vault_credentials / vault_credential_grants writes to the
 * self-contained `moreece-vault` Lambda (NOT authorised-write), so the shared
 * write Lambda stays untouched. The Lambda KMS-encrypts the password server-side
 * on insert/update of vault_credentials, admin-gates vault_credential_grants, and
 * writes the vault_activity_log audit rows itself.
 *
 * Same call signature as authWrite so the vault components are a drop-in swap:
 *   await vaultWrite(session, 'vault_credentials', 'insert', payload);
 *   await vaultWrite(session, 'vault_credentials', 'update', payload, { column: 'id', value: id });
 *   await vaultWrite(session, 'vault_credential_grants', 'insert', payload);
 */

const FUNC_URL = import.meta.env.VITE_AWS_VAULT_READ_URL;

export async function vaultWrite(session, table, action, payload, match) {
  if (!FUNC_URL) {
    throw new Error(
      '[vaultWrite] VITE_AWS_VAULT_READ_URL is not set. ' +
      'The Vault backend has not been deployed yet — see app/.env.example.'
    );
  }
  const res = await fetch(FUNC_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      pin: session?.code,
      table,
      action,
      payload: payload || undefined,
      match: match || undefined,
    }),
  });
  const json = await res.json();
  if (!res.ok) {
    throw new Error(json.error || `Vault write failed: ${res.status}`);
  }
  return json.data;
}
